import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Dependable Printing Solutions",
  "Crafted with Precision",
  "Business Cards",
  "Brochures & Flyers",
  "Books & Booklets",
  "Promotional Materials",
  "Banners & Signage",
  "Custom Projects",
  "Since 1994",
];

export default function EditorialMarquee({ dark = false }) {
  return (
    <section
      className={`py-14 md:py-20 border-y ${dark ? "bg-[color:var(--bg-charcoal)] text-white border-white/10" : "bg-[color:var(--bg)] text-[color:var(--text)] border-black/5"}`}
      data-testid="marquee-section"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="flex items-center gap-8 md:gap-14 pr-8 md:pr-14 font-display italic text-5xl md:text-7xl tracking-tight">
            {t}
            <Asterisk className={`w-8 h-8 md:w-10 md:h-10 ${dark ? "text-[color:var(--accent)]" : "text-[color:var(--accent)]"}`} />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
